import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, useLocation } from "react-router-dom";
import NotFound from './components/NotFound/NotFound';

async function loadConfig() {
  try {
    const response = await fetch("/config/dataharbor_config.json");
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error loading config:", error);
    return {};
  }
}

loadConfig().then((config) => {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  );
});

const Root = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const company = queryParams.get("dm");

  if (!company) {
    return <NotFound />;
  }

  return (
    <App cmp={company} />
  );
};